export default __webpack_public_path__ + "static/marquee_bar-009668b864011f21616eb74259d80056.webp";